export default __webpack_public_path__ + "static/img2-5a78331e329bc815ca4062d1031d687e.png";